import { Inject, Injectable, numberAttribute, Optional } from '@angular/core';
import { PAGE_OFFSET_CONFIGURATION } from '../core-injection.tokens';

@Injectable({
  providedIn: 'root'
})
export class StickyService {
  private static readonly DEFAULT_OFFSET: number = 50;
  private readonly pageOffset: number = 0;

  constructor(@Optional() @Inject(PAGE_OFFSET_CONFIGURATION) pageOffsetConfiguration: number) {
    this.pageOffset = numberAttribute(pageOffsetConfiguration, StickyService.DEFAULT_OFFSET);
  }

  getPageOffset(): number {
    return this.pageOffset;
  }
}
